<script>
import axios from 'axios';
import numeral from 'numeral';

export default {
    name: "DetilRiwayatPembayaran",
    props: {
        dialog: Boolean,
        item: Object,
    },
    data() {
        return {
            isLoading: false,
            internalDialog: this.dialog,

            mahasiswa: Object,
            rangkumanRiwayat: Object,

            tableHeaders: [
                { text: 'Nama Tagihan', value: 'nama_tagihan' },
                { text: 'Semester', value: 'semester' },
                { text: 'Periode', value: 'periode' },
                { text: 'Batas Pembayaran', value: 'batas_pembayaran' },
                { text: 'Nominal', value: 'nominal' },
                { text: 'Terbayar', value: 'terbayar' }
            ],
            tableItems: [],
            options: {},
            pagination: {
                currentPage: 1,
                lastPage: 0,
                perPage: 0,
                total: 0
            },
        };
    },
    watch: {
        dialog(isOpened) {
            this.internalDialog = isOpened;
            
            if (isOpened && this.item?.source && this.item?.receipt_id) {
                this.fetchData();
            }
        },

        internalDialog(isOpened) {
            if (isOpened !== this.dialog) {
                this.$emit("update:dialog", isOpened);
            }
        }
    },
    methods: {
        fetchData() {
            this.isLoading = true;

            const endpoint = `${process.env.VUE_APP_ROOT_API}/api/ortu/riwayat-pembayaran/${this.item.source}/${this.item.receipt_id}`
            const { page = 1, itemsPerPage = 10 } = this.options;
            axios.get(endpoint, {
                params: { page }
            })
                .then((response) => {
                    this.mahasiswa = response.data.mahasiswa;
                    this.rangkumanRiwayat = response.data.rangkuman;

                    const tagihan = response.data.tagihan;
                    this.tableItems = tagihan.data.map((item) => ({
                        nama_tagihan: item.nama_tagihan,
                        semester: item.semester,
                        periode: `${item.nama_semester} ${item.tahun_ajaran}`,
                        batas_pembayaran: item.batas_pembayaran,
                        nominal: `Rp ${numeral(item.nominal).format('0,0')}`,
                        terbayar: `Rp ${numeral(item.terbayar).format('0,0')}`
                    }));

                    this.pagination.currentPage = tagihan.current_page;
                    this.pagination.lastPage = tagihan.last_page;
                    this.pagination.perPage = tagihan.per_page;
                    this.pagination.total = tagihan.total;
                })
                .catch((error) => {

                })
                .finally(() => { 
                    this.isLoading = false; 
                })
        },

        onOptionsChanged(newOptions) {
            const { page, itemsPerPage } = newOptions;

            const pageChanged = page !== this.options.page;
            const perPageChanged = itemsPerPage !== this.options.itemsPerPage;

            this.options = { ...newOptions };

            if (pageChanged || perPageChanged) {
                this.fetchData();
            }
        },

        onPageChanged() {
            this.options.page = this.pagination.currentPage;
            this.fetchData();
        }
    },
    filters: {
        formatNumber(value) {
            return `Rp ${numeral(value).format('0, 0')}`
        }
    }
};
</script>

<template>
    <div class="dialog">
        <v-dialog v-model="internalDialog" max-width="960px" @input="$emit('update:dialog', internalDialog)">
            <v-card>
                <v-card-title>
                    <span class="headline">Detil Riwayat Pembayaran</span>
                </v-card-title>


                <v-card-text>
                    <div class="card card-body mb-3" v-if="rangkumanRiwayat">
                        <dl class="row">
                            <dt class="col-sm-4 py-0">Jenis</dt>
                            <dd class="col-sm-8 py-0 text-capitalize">{{ rangkumanRiwayat.source_description }}</dd>
                            <dt class="col-sm-4 py-0">No. Transaksi</dt>
                            <dd class="col-sm-8 py-0">{{ rangkumanRiwayat.no_transaksi }}</dd>
                            <dt class="col-sm-4 py-0">Tanggal Transaksi</dt>
                            <dd class="col-sm-8 py-0">{{ rangkumanRiwayat.tanggal_pembayaran }}</dd>
                            <dt class="col-sm-4 py-0">Nominal</dt>
                            <dd class="col-sm-8 py-0">{{ rangkumanRiwayat.pembayaran | formatNumber }}</dd>
                        </dl>
                    </div>

                    <p class="fw-bold mb-1">Rincian Pembayaran</p>
                    <v-data-table 
                        :loading="isLoading" 
                        :headers="tableHeaders" 
                        :items="tableItems"
                        :options.sync="options" 
                        :page="pagination.currentPage" 
                        :pageCount="pagination.lastPage"
                        :items-per-page="pagination.perPage" 
                        :server-items-length="pagination.total"
                        @update:options="onOptionsChanged" 
                        hide-default-footer 
                        class="elevation-1">
                    </v-data-table>

                    <v-pagination v-model="pagination.currentPage" :length="pagination.lastPage" @input="onPageChanged" />
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="internalDialog = false">Tutup</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>